import { aboutInfo, FAQData } from "@/mocks/data";

export default function AboutPage() {
  return (
    <main className="min-h-screen pt-16 bg-background-50">
      {/* About Hero */}
      <section className="relative w-full h-[400px] md:h-[480px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Team%20of%20young%20Asian%20travel%20creators%20working%20together%20in%20a%20bright%20modern%20creative%20studio%20with%20world%20map%20on%20wall%20laptops%20and%20cameras%20on%20wooden%20table%20warm%20natural%20light%20streaming%20through%20large%20windows%20collaborative%20atmosphere%20travel%20magazine%20office%20vibe%20professional%20photography&width=1600&height=800&seq=about-hero-01&orientation=landscape"
          alt="亚洲天堂团队"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white text-center mb-3">
            关于我们
          </h1>
          <p className="text-white/70 text-sm md:text-lg text-center max-w-xl">
            用心发现亚洲的每一处美好
          </p>
        </div>
      </section>

      {/* Brand Introduction */}
      <section className="bg-background-50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-3xl mx-auto text-center mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              品牌故事
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6">
              {aboutInfo.brandIntro}
            </p>
            <p className="text-foreground-600 text-sm leading-relaxed">
              {aboutInfo.mission}
            </p>
          </div>

          {/* Timeline */}
          <div className="max-w-4xl mx-auto">
            <h3 className="font-heading text-xl font-bold text-foreground-900 text-center mb-10">
              发展历程
            </h3>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
              {aboutInfo.story.map((item, idx) => (
                <div
                  key={item.year}
                  className={`relative flex items-start mb-10 ${
                    idx % 2 === 0
                      ? "md:flex-row md:pr-[50%]"
                      : "md:flex-row-reverse md:pl-[50%]"
                  } pl-12 md:pl-0`}
                >
                  <div className="absolute left-2 md:left-1/2 w-5 h-5 rounded-full bg-primary-500 border-4 border-background-50 -translate-x-1/2 z-10"></div>
                  <div className="bg-white rounded-xl p-5 border border-background-200/70 w-full md:w-auto md:max-w-[380px]">
                    <span className="inline-block bg-primary-100 text-primary-700 text-xs font-bold px-3 py-1 rounded-full mb-2">
                      {item.year}
                    </span>
                    <h4 className="font-heading text-base font-bold text-foreground-900 mb-2">
                      {item.title}
                    </h4>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Reputation */}
      <section className="bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              用户口碑
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              来自旅行者的真实评价，是我们不断前进的动力
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {aboutInfo.reputation.map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl p-5 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                    <p className="text-xs text-foreground-400">{item.location}</p>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-2">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-primary-500 text-xs"></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                  {item.comment}
                </p>
                <p className="text-xs text-foreground-400">{item.date}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="bg-background-50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              联系我们
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              欢迎合作洽谈、旅行建议和内容投稿
            </p>
          </div>

          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            {[
              { icon: "ri-mail-line", label: "电子邮箱", value: aboutInfo.contact.email },
              { icon: "ri-phone-line", label: "联系电话", value: aboutInfo.contact.phone },
              { icon: "ri-map-pin-line", label: "办公地址", value: aboutInfo.contact.address },
            ].map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl p-6 border border-background-200/70 text-center"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h4 className="font-heading text-sm font-bold text-foreground-900 mb-2">
                  {item.label}
                </h4>
                <p className="text-sm text-foreground-500 break-all">{item.value}</p>
              </div>
            ))}
          </div>

          <div className="max-w-3xl mx-auto flex items-center justify-center gap-6">
            {[
              { icon: "ri-wechat-line", label: "微信", value: aboutInfo.contact.wechat },
              { icon: "ri-weibo-line", label: "微博", value: aboutInfo.contact.weibo },
            ].map((item, idx) => (
              <div key={idx} className="flex items-center gap-3 bg-white rounded-xl px-5 py-3 border border-background-200/70">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-400">{item.label}</p>
                  <p className="text-sm font-medium text-foreground-800">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
          </div>
          <div className="max-w-3xl mx-auto space-y-3">
            {FAQData.map((faq, i) => (
              <details
                key={i}
                className="group bg-white rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
              >
                <summary className="flex items-center justify-between p-5 font-medium text-foreground-800 text-sm list-none">
                  {faq.question}
                  <span className="w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-500 leading-relaxed">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}